var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.439 5.2978C16.04 5.46167 16.5131 5.9445 16.6737 6.55764C16.9656 7.6689 16.9656 9.98754 16.9656 9.98754C16.9656 9.98754 16.9656 12.3061 16.6737 13.4175C16.5131 14.0306 16.04 14.5134 15.439 14.6774C14.35 14.9751 9.98279 14.9751 9.98279 14.9751C9.98279 14.9751 5.61561 14.9751 4.52653 14.6774C3.9257 14.5134 3.45245 14.0306 3.29185 13.4175C3 12.3061 3 9.98754 3 9.98754C3 9.98754 3 7.6689 3.29185 6.55764C3.45245 5.9445 3.9257 5.46167 4.52653 5.2978C5.61561 5 9.98279 5 9.98279 5C9.98279 5 14.35 5 15.439 5.2978ZM12.2046 9.98762L8.55449 12.0927V7.8824L12.2046 9.98762Z",
    fill: "#47494B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/Social_Youtube.e084718866a97a79e982aa2718227471.svg";
export { ForwardRef as ReactComponent };